<script lang="ts">
	import type { Snippet } from 'svelte';

	let props: {
		top?: number;
		bottom?: number;
		left?: number;
		right?: number;
		all?: number;
		vertical?: number;
		horizontal?: number;
		children?: Snippet;
	} = $props();

	let _top = $derived(props.all || props.vertical || props.top || 0);
	let _bottom = $derived(props.all || props.vertical || props.bottom || 0);
	let _left = $derived(props.all || props.horizontal || props.left || 0);
	let _right = $derived(props.all || props.horizontal || props.right || 0);
</script>

<div class={`mt-${_top} mb-${_bottom} ml-${_left} mr-${_right}`}>
	{@render props.children?.()}
</div>
